import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Spinner } from '@app/shared/components/spinner/spinner';

/**
 * Reusable wrapper for pages that load data via API.
 * Displays centered full-page loader or error state; projects content when ready.
 * Parent handles GET/POST and sets isLoading, isError, errorMessage, errorDetails.
 */
@Component({
  selector: 'app-api-state-wrapper',
  standalone: true,
  imports: [CommonModule, Spinner],
  templateUrl: './api-state-wrapper.html',
  styleUrl: './api-state-wrapper.scss',
})
export class ApiStateWrapper {
  @Input() isLoading = false;
  @Input() isError = false;
  @Input() errorMessage = '';
  @Input() errorDetails = '';
  @Input() retryLabel = 'Try Again';
  @Input() refreshLabel = 'Refresh Page';

  @Output() retry = new EventEmitter<void>();
  @Output() refreshPage = new EventEmitter<void>();

  onRetry(): void {
    this.retry.emit();
  }

  onRefreshPage(): void {
    this.refreshPage.emit();
  }
}
